import { render } from "./truckElectrik.vue?vue&type=template&id=74227de3&scoped=true"
import script from "./truckElectrik.vue?vue&type=script&lang=js"
export * from "./truckElectrik.vue?vue&type=script&lang=js"

import "./truckElectrik.vue?vue&type=style&index=0&id=74227de3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74227de3"]])

export default __exports__